import { getAssociatedTokenAddressSync } from "@solana/spl-token";
import { PublicKey, TransactionInstruction } from "@solana/web3.js";
import BN from "bn.js";
import { ReferralProgram, StakingAccount } from "../type";
import { deriveStakingAuthority } from "../pda";

export interface IImmediateUnstakeParams {
  referralProgram: ReferralProgram;
  stakingAddress: PublicKey;
  stakingAccount: StakingAccount;
  escrowAddress: PublicKey;
  owner: PublicKey;
  maxAmount: BN;
  maxImmediateUnstakePenaltyBps: number;
  receiver: PublicKey;
}

export async function createImmediateUnstakeIx(
  params: IImmediateUnstakeParams,
): Promise<TransactionInstruction> {
  const {
    referralProgram,
    stakingAddress,
    stakingAccount,
    escrowAddress,
    owner,
    maxAmount,
    maxImmediateUnstakePenaltyBps,
    receiver,
  } = params;

  const ownerTokenVault = getAssociatedTokenAddressSync(
    stakingAccount.tokenMint,
    receiver,
    true,
  );

  return referralProgram.methods
    .immediateUnstake({
      maxAmount,
      maxImmediateUnstakePenaltyBps,
      padding0: Array(5).fill(new BN(0)),
    })
    .accountsPartial({
      escrow: escrowAddress,
      staking: stakingAddress,
      stakingAuthority: deriveStakingAuthority(referralProgram.programId),
      tokenVault: stakingAccount.tokenVault,
      tokenMint: stakingAccount.tokenMint,
      ownerTokenVault,
      owner,
    })
    .instruction();
}
